/* eslint-disable camelcase */
import { useContext, useState } from "react"
import Header from "../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box } from "@mui/material"
import BackIcon from "../../../components/BackIcon"
import { useNavigate } from "react-router-dom"
import CustomConditionalActionsTableServer from "../../../components/CustomConditionalActionsTableServerSide"
import normalFormatDate from "../../utils/date/DDMMYYYFormatDate"
import { GlobalContext } from "../../../contexts/GlobalContext"
import { useMutation, api } from "../../../api"
import getIconComponent from "../../utils/getIconComponent"
import CustomBackdrop from "../../../components/CustomBackdrop"
import { useQueryClient } from "@tanstack/react-query"
import {
  handleExportDataPdfLGScreen,
  handleExportDataPdfSMScreen,
  handleAllExportDataCSV,
} from "../../utils/reactTableActions/exportToolbarActions"
import ModalImportCSV from "../../../components/CustomCSVImportButton"

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const theme = createTheme({
  palette: { primary: { main: "#196C87" }, secondary: { main: "#196C87" } },
})

const Candidatos = () => {
  const qc = useQueryClient()
  const navigate = useNavigate()
  const { selectedMenuInfo } = useContext(GlobalContext)
  const [openModal, setOpenModal] = useState(false)

  let barraAcciones = selectedMenuInfo?.data?.barraAcciones
  if (!barraAcciones || barraAcciones.length === 0) {
    try {
      const menuAccionesRaw = localStorage.getItem("menuAcciones")
      if (menuAccionesRaw) {
        const menuAcciones = JSON.parse(menuAccionesRaw)
        const currentMenu = menuAcciones["ControlElectoral/Candidatos"]
        if (currentMenu && currentMenu.barraAcciones) barraAcciones = currentMenu.barraAcciones
      }
    } catch (error) {
      console.error("Error leyendo permisos:", error)
    }
  }

  const { mutateAsync: SaveEliminacionCandidato, isPending: isDeletingCandidato } = useMutation({
    queryKey: ["isDeletingCandidato"],
    fn: async (data) => {
      const response = await api.post("/ControlElectoral/eliminarCandidato", data)
      return response.data
    },
    showError: "modal",
    showSuccess: "toast",
    onSuccess: async () => await qc.invalidateQueries({ queryKey: ["Candidatos"] }),
  })

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Catálogo de Candidatos</b>
        </div>
        <CustomBackdrop isLoading={isDeletingCandidato} />

        <Box className={StyledRoot}>
          {/* ======================================================== */}
          {/* AJUSTE CSV: Actualizado cand_dignidad a dig_codigo         */}
          {/* ======================================================== */}
          <ModalImportCSV
            open={openModal}
            onClose={() => setOpenModal(false)}
            templateFileName="PlantillaCreacionCandidatos.csv"
            fieldConfigs={{
              cand_codigo: { required: true, key: true },
              dig_codigo: { required: true }, // MODIFICADO PARA LA BD NORMALIZADA
              cand_nombre: { required: true },
              cand_partido: { required: true },
              cand_lista: { required: true },
              cand_orden: { required: true },
            }}
            maxFileSize={10 * 1024 * 1024}
            validateEndpoint="/ControlElectoral/validarCandidatosIMP"
            insertEndpoint="/ControlElectoral/insertarCandidatosIMP"
            onImportComplete={() => qc.invalidateQueries({ queryKey: ["Candidatos"] })}
          />

          <CustomConditionalActionsTableServer
            endpoint="/ControlElectoral/getAllCandidatos"
            errorMsgFilterSearch="Error al cargar los candidatos"
            queryKeyModal="Candidatos"
            perPage={10}
            rowActionsWidthTable={120}
            rowActions={(row) => {
              const editarAction = barraAcciones?.find((action) => action?.acccaption === "EDITAR")
              const eliminarAction = barraAcciones?.find((action) => action?.acccaption === "ELIMINAR")

              return [
                {
                  label: editarAction?.acccaption,
                  key: editarAction?.acccaption,
                  icon: getIconComponent(editarAction?.accnameicono, editarAction?.acctipoico),
                  onClick: (row) => navigate("editar", { state: row.original }),
                },
                {
                  label: eliminarAction?.acccaption,
                  key: eliminarAction?.acccaption,
                  icon: getIconComponent(eliminarAction?.accnameicono, eliminarAction?.acctipoico),
                  onClick: async (row) => {
                    try {
                      await SaveEliminacionCandidato({ cand_codigo: row.original.cand_codigo })
                    } catch (err) {
                      console.error("Error eliminando", err)
                    }
                  },
                },
              ]
            }}
            topToolbarCustomActions={({ table, device }) => {
              const crearAction = barraAcciones?.find((action) => action?.acccaption === "CREAR")
              const exportarAction = barraAcciones?.find((action) => action?.acccaption === "EXPORTAR")
              const importarAction = barraAcciones?.find((action) => action?.acccaption === "IMPORTAR")

              return [
                {
                  label: crearAction?.acccaption,
                  key: crearAction?.acccaption,
                  icon: getIconComponent(crearAction?.accnameicono, crearAction?.acctipoico),
                  onClick: () => navigate("crear"),
                },
                {
                  type: "dropdown",
                  label: exportarAction?.acccaption,
                  key: "exportarDropdown",
                  icon: getIconComponent(exportarAction?.accnameicono, exportarAction?.acctipoico),
                  actions: [
                    {
                      label: "Exportar PDF",
                      key: "exportarPDF",
                      icon: getIconComponent(exportarAction?.accnameicono, exportarAction?.acctipoico),
                      onClick: ({ columns, data }) => {
                        if (device === "sm")
                          return handleExportDataPdfSMScreen(
                            columns,
                            data,
                            "Reporte",
                            `Reporte ${new Date().toLocaleString()}`,
                          )
                        handleExportDataPdfLGScreen(
                          columns,
                          table.getCoreRowModel().rows,
                          "Reporte",
                          `Reporte ${new Date().toLocaleString()}`,
                        )
                      },
                    },
                    {
                      label: "Exportar CSV",
                      key: "exportarCSV",
                      icon: getIconComponent(exportarAction?.accnameicono, exportarAction?.acctipoico),
                      onClick: ({ data }) => handleAllExportDataCSV(data, `Reporte ${new Date().toLocaleString()}`),
                    },
                  ],
                },
                {
                  label: importarAction?.acccaption,
                  key: importarAction?.acccaption,
                  icon: getIconComponent(importarAction?.accnameicono, importarAction?.acctipoico),
                  onClick: () => setOpenModal(true),
                },
              ]
            }}
            columnsTable={[
              {
                accessorKey: "cand_codigo",
                header: "Código",
                size: 100,
                Cell: ({ cell }) => <span style={{ fontWeight: "bold" }}>{cell.getValue()}</span>,
              },
              {
                accessorKey: "cand_dignidad",
                header: "Dignidad",
                size: 150,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "cand_nombre",
                header: "Nombre del Candidato",
                size: 250,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "cand_partido",
                header: "Partido Político",
                size: 200,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "cand_lista",
                header: "Lista",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "cand_orden",
                header: "Ord. Papeleta",
                size: 120,
                Cell: ({ cell }) => <span style={{ textAlign: "center", display: "block" }}>{cell.getValue()}</span>,
              },
              {
                accessorKey: "cand_estado",
                header: "Estado",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue() === "A" ? "ACTIVO" : "INACTIVO"}</span>,
              },
              {
                accessorKey: "aud_fecisys",
                header: "Fecha de Registro",
                size: 160,
                Cell: ({ cell }) => <span>{normalFormatDate(cell.getValue())}</span>,
              },
              {
                accessorKey: "aud_usuisys",
                header: "Registrado Por",
                size: 150,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
            ]}
          />
        </Box>
      </div>
    </ThemeProvider>
  )
}
export default Candidatos
